import axios from 'lib/axios'

export interface Test360DraftProps {
  test360: Test360Class
}

export interface Test360Class {
  skills360?: Skills360[]
  users?: Evaluator[]
  evaluators?: Evaluator[]
  step?: number
  finalDate?: string
  process_id?: number
}

export interface Evaluator {
  role?: string
  email: string
  first_name?: string
  last_name?: string
  evaluators?: Evaluator[]
}

export interface Skills360 {
  name: string
  description: string
  questions: string[]
}

interface Test360UpdateDraftResponse {
  success: boolean
  message: string
  data?: any
}

const test360UpdateDraft = async (process_id: number, body: Test360DraftProps): Promise<Test360UpdateDraftResponse> => {
  const apiUrl = `/process/draft/${process_id}`

  try {
    const response = await axios.put(apiUrl, body)
    return response.data
  } catch (error: any) {
    console.error('error updating test 360 draft', error)
    return {
      success: false,
      message: error?.response?.data?.message || 'Error al actualizar el borrador Test 360',
      data: error?.response?.data
    }
  }
}

export default test360UpdateDraft
